const process = require('./src/standalone/index.js');

module.exports = process;
